import React from "react";
import Language from "../language/language";
// import { Button } from 'antd'
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { $const, $util } from "../../helper";

/******form list********/
import GameForm from "../formList/gameForm";
import GameJudgeForm from "../formList/gameJudgeForm";
import GameMeetingForm from "../formList/gameMeetingForm";
import GameFormHistory from "../formList/gameFormHistory/index";
import CountDown from "../common/countDown";

import "./stylesheets/gameInfoItem.scss";
import moment from "moment";

@inject("languageStore", "gameStore", "teamStore", "personGameStore")
@observer
export default class GameInfoItem extends React.Component {
  state = {
    allDesc: false,
    showFormHistory:
      this.props.gameData &&
      this.props.gameData.event &&
      this.props.gameData.event.category &&
      this.props.gameData.event.category.eventType === 999
        ? true
        : false,
    registrationStageStatusId: undefined,
    isCountDown: true,
    target: 0
  };
  componentDidMount() {
    this.getQuizData();
  }
  getQuizData(isAuto) {
    const node = this.props.node;
    if (this.props.node.stageType === $const.STAGE_TYPE.JUDGE) {
      let registrationStageStatusId;
      let gameData = this.props.gameData;
      gameData &&
        gameData.registrationStageStatuses &&
        gameData.registrationStageStatuses.nodes &&
        gameData.registrationStageStatuses.nodes.forEach(node => {
          if (node.stageId === this.props.stageId) {
            registrationStageStatusId = node.id;
          }
        });
      if (registrationStageStatusId) {
        this.props.teamStore
          .getQuizeHistory(
            registrationStageStatusId,
            this.props.stageId,
            node.myStageStatus !== $const.STAGE_STATUS.PASS &&
              node.myStageStatus !== $const.STAGE_STATUS.FAIL,
            isAuto
          )
          .then(() => {
            this.setState({
              registrationStageStatusId: registrationStageStatusId
            });
            if (
              this.props.teamStore.quiz &&
              this.props.teamStore.quiz[registrationStageStatusId] &&
              this.props.teamStore.quiz[registrationStageStatusId].history
            ) {
              const history = this.props.teamStore.quiz[registrationStageStatusId].history;
              const pendingList = history.filter(item => item.status === "pending");
              const endAt = pendingList.length && pendingList[0].endAt;
              const now = moment().valueOf();
              this.setState({
                isCountDown: moment(endAt).valueOf() - now > 0,
                target: endAt
              });
            }
          });
      }
    }
  }
  showAllInfo = () => {
    this.setState({
      allDesc: true
    });
  };
  closeAllInfo = () => {
    this.setState({
      allDesc: false
    });
  };

  showFormDetail = () => {
    this.setState({
      showFormHistory: !this.state.showFormHistory
    });
  };

  renderFormHistroy = (history, formId, node) => {
    const stageMap = this.props.teamStore.stageMap;
    // isMutiJudge 表示用户当前是否在多人测评环节，不代表当前渲染的 GameFormHistory 是否为多人测评环节
    const isMutiJudge = stageMap[this.props.stageId] && stageMap[this.props.stageId].forMultiPeople;
    const registrationStageStatusId = this.state.registrationStageStatusId;

    if (node.stageType === $const.STAGE_TYPE.JUDGE && isMutiJudge) {
      return (
        registrationStageStatusId && (
          <GameFormHistory
            myFlow={this.props.myFlow}
            gameData={this.props.gameData}
            stageId={node.id}
            history={history}
            node={node}
            formId={formId}
            isMutiJudge={isMutiJudge}
            registrationStageStatusId={registrationStageStatusId}
          />
        )
      );
    }
    if (node.stageType === $const.STAGE_TYPE.MEETING) {
      if (!(node.meeting && node.meeting.hasSubmittedMeeting)) return null;
    } else if (history.length < 1) {
      return null;
    }
    // 尚未开始不展示历史记录
    if (moment() < moment(node.beginAt)) {
      return null;
    }
    // 渲染测评表单结果，例如有效分数，提交时间。
    return (
      <GameFormHistory
        myFlow={this.props.myFlow}
        gameData={this.props.gameData}
        stageId={node.id}
        history={history}
        node={node}
        formId={formId}
      />
    );
  };

  renderSummary = (node, lang) => {
    let summary = "";
    if (node && node.paragraphs && node.paragraphs.nodes && node.paragraphs.nodes.length > 0) {
      node.paragraphs.nodes.forEach(item => {
        if (item.paragraphType === $const.PARAGRAPHTYPE.SUMMARY) {
          summary = item.nameUuidI18n[lang];
        }
      });
    }
    return (
      <span
        className="summary"
        dangerouslySetInnerHTML={{
          __html: summary
        }}
      />
    );
  };

  renderDetail = detail => {
    return (
      <div
        className="detail-info"
        dangerouslySetInnerHTML={{
          __html: detail
        }}
      />
    );
  };

  checkCurrent = (id, parentStageId, node) => {
    let current = false;
    // 是否是当前状态
    const gameData = this.props.gameData;
    const stageId = this.props.stageId;
    const myFlow = this.props.myFlow;
    const stageIdMajorNum = this.props.stageIdMajorNum;
    if (gameData && gameData.stageId === id) {
      // 非虚拟节点
      current = true;
    }
    if (!gameData && this.props.index === 0) {
      // 没有数据 且第一个环节
      current = true;
    }
    if (gameData && gameData.stageId === parentStageId) {
      // 虚拟节点 的子节点
      current = true;
    }
    if (node.isOptional && stageIdMajorNum !== undefined && this.props.index <= stageIdMajorNum) {
      // 虚拟环节的子节点（是选做环节的时候） 只要当前环节走到或者走过就处于环节之内
      current = true;
    }
    if (gameData && this.props.index === 0 && stageId) {
      // 变更流程导致的报名环节显示不出来
      let slug = true;
      myFlow &&
        myFlow.stages &&
        myFlow.stages.nodes &&
        myFlow.stages.nodes.forEach(item => {
          if (item.id === stageId) {
            slug = false;
          }
        });
      if (slug) {
        // 新的报名环节
        current = true;
      }
    }
    return current;
  };

  formatInput = formInputs => {
    let inputs = [];
    formInputs.forEach(input => {
      if (input.inputSource === $const.INPUTSOURCE.WWW) {
        inputs.push(input);
      }
    });
    return inputs;
  };

  feedBackInput = formInputs => {
    let inputs = [];
    formInputs.forEach(input => {
      if (input.inputSource === $const.INPUTSOURCE.CMS) {
        inputs.push(input);
      }
    });
    return inputs;
  };

  formCommonInputs = gameData => {
    let inputs = [];
    if (gameData && gameData.id) {
      inputs = gameData.commonInputs;
    }
    return inputs;
  };
  /*
   * 返回是否已经达到提交限制
   * true 已达到提交限制  false 未达到提交限制
   */
  getFormIsSubmit = forms => {
    let slug = false;
    if (forms.length < 1) {
      return null;
    }
    let form = forms[0];
    let formId = form.id;
    let num = 0;
    // 每次提交皆会刷新数据 所以只存在等于
    const gameData = this.props.gameData;
    if (gameData && gameData.id) {
      if (
        gameData.commonInputs &&
        gameData.commonInputs.nodes &&
        gameData.commonInputs.nodes.length > 0
      ) {
        num = this.sumHistory(formId, gameData.commonInputs.nodes);
        if (num === form.numLimit) {
          slug = true;
        }
      }
    }
    return slug;
  };

  sumHistory = (formId, nodes) => {
    let num = 0;
    nodes.forEach(item => {
      if (item.formId === formId) {
        num += 1;
      }
    });
    return num;
  };

  renderHistroy = (node, isCurrent, submitLimit, history, formId) => {
    const stageIdMajorNum = this.props.stageIdMajorNum;
    // 未开始的环节 不展示
    if (stageIdMajorNum !== undefined && node.majorNum > stageIdMajorNum) {
      return null;
    }
    // 处于  当前环节;  LOOP环节 的 特殊处理
    // 当前环节 不是 LOOP 环节  且 不是  失败 与 通过（状态优先法则）， 且没达到上限次数的
    if (
      (isCurrent && node.stageType === $const.STAGE_TYPE.LOOP) ||
      (isCurrent &&
        node.stageType !== $const.STAGE_TYPE.LOOP &&
        node.myStageStatus !== $const.STAGE_STATUS.PASS &&
        node.myStageStatus !== $const.STAGE_STATUS.FAIL &&
        !submitLimit &&
        moment() < moment(this.props.node.endAt))
    ) {
      // 如果是子环节，父环节有状态 则不显示   => 他会显示已关闭
      if (
        !this.state.showFormHistory &&
        node.parentStageId &&
        !node.isOptional &&
        (node.parentStageStatus === $const.STAGE_STATUS.FAIL ||
          node.parentStageStatus === $const.STAGE_STATUS.PASS)
      ) {
        return null;
      }
      return <div className="history">{this.renderFormHistroy(history, formId, node)}</div>;
    }
    if (this.state.showFormHistory) {
      return <div className="history">{this.renderFormHistroy(history, formId, node)}</div>;
    }
  };

  renderNotBegin = (isCurrent, node) => {
    // 处于当前环节 且 时间未开始  且状态不能等于 失败或者通过 （状态优先法则）
    if (
      isCurrent &&
      moment() < moment(node.beginAt) &&
      node.myStageStatus !== $const.STAGE_STATUS.FAIL &&
      node.myStageStatus !== $const.STAGE_STATUS.PASS
    ) {
      // 如果是子环节，父环节有状态 则不显示  => 他会显示已关闭
      if (
        node.parentStageId &&
        !node.isOptional &&
        (node.parentStageStatus === $const.STAGE_STATUS.FAIL ||
          node.parentStageStatus === $const.STAGE_STATUS.PASS)
      ) {
        return null;
      }
      return (
        <div className="node-finish">
          <div className="status  grey">
            <Language resource="NOT_BEGIN" />
          </div>
        </div>
      );
    }
    return null;
  };

  renderIsEnd = (isCurrent, node, history) => {
    // 处于当前环节 且 时间已结束 且 状态不能 等于 失败 或者通过 （状态优先法则）
    if (
      isCurrent &&
      moment() > moment(node.endAt) &&
      node.myStageStatus !== $const.STAGE_STATUS.FAIL &&
      node.myStageStatus !== $const.STAGE_STATUS.PASS
    ) {
      // 如果是子环节，父环节有状态 则不显示   => 他会显示已关闭
      if (
        node.parentStageId &&
        !node.isOptional &&
        (node.parentStageStatus === $const.STAGE_STATUS.FAIL ||
          node.parentStageStatus === $const.STAGE_STATUS.PASS)
      ) {
        return null;
      }
      return (
        <div className="node-finish">
          <div className="status  grey">
            <Language resource="IS_END" />
          </div>
          {history.length > 0 || (node.meeting && node.meeting.hasSubmittedMeeting) ? (
            <div className="show-form spe-link" onClick={this.showFormDetail.bind(this)}>
              {this.state.showFormHistory ? (
                <Language resource="PACK_UP" />
              ) : (
                <Language resource="VIEW" />
              )}
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  renderSubmitLimit = (isCurrent, node, submitLimit, history, isOverLimitCur) => {
    // 处于当前环节 （loop环节不受限制） 状态不能等于通过与失败（状态优先） 时间在范围之内
    if (
      isCurrent &&
      node.stageType !== $const.STAGE_TYPE.LOOP &&
      node.myStageStatus !== $const.STAGE_STATUS.FAIL &&
      node.myStageStatus !== $const.STAGE_STATUS.PASS &&
      (submitLimit || isOverLimitCur) &&
      moment() > moment(this.props.node.beginAt) &&
      moment() < moment(this.props.node.endAt)
    ) {
      // 如果是子环节，父环节有状态 则不显示   => 他会显示已关闭
      if (
        node.parentStageId &&
        !node.isOptional &&
        (node.parentStageStatus === $const.STAGE_STATUS.FAIL ||
          node.parentStageStatus === $const.STAGE_STATUS.PASS)
      ) {
        return null;
      }
      return (
        <div className="node-finish">
          <div className={submitLimit ? "status status_all grey" : "status status_cur grey"}>
            <Language resource={submitLimit ? "SUBMIT_LIMIT" : "SUBMIT_LIMIT_CUR"} />
          </div>
          {history.length > 0 ? (
            <div className="show-form spe-link" onClick={this.showFormDetail.bind(this)}>
              {this.state.showFormHistory ? (
                <Language resource="PACK_UP" />
              ) : (
                <Language resource="VIEW" />
              )}
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  /*
   * 具体表单信息
   */
  renderFormContent = (form, status, formInputs, feedBackInputs, canSubmit, submitCount) => {
    const stageMap = toJS(this.props.teamStore.stageMap);
    const isMutiJudge =
      this.props.node.stageType === $const.STAGE_TYPE.JUDGE &&
      stageMap[this.props.stageId] &&
      stageMap[this.props.stageId].forMultiPeople;
    const registrationStageStatusId = this.state.registrationStageStatusId;
    if (this.props.node.stageType === $const.STAGE_TYPE.JUDGE && isMutiJudge) {
      // 多人测评特殊处理
      return (
        registrationStageStatusId && (
          <GameJudgeForm
            gameData={this.props.gameData}
            stageId={this.props.node.id}
            isCaptain={this.props.teamStore.teamInfo.isCaptain}
            registrationStageStatusId={registrationStageStatusId}
          ></GameJudgeForm>
        )
      );
    }
    if (!canSubmit) {
      return null;
    }
    if (
      !form &&
      this.props.node.stageType !== $const.STAGE_TYPE.JUDGE &&
      this.props.node.stageType !== $const.STAGE_TYPE.MEETING
    ) {
      return null;
    }
    if (
      (this.props.node.stageType === $const.STAGE_TYPE.JUDGE ||
        this.props.node.stageType === $const.STAGE_TYPE.MEETING) &&
      this.props.gameType === $const.SOURCE_TYPE.TEAM &&
      !this.props.teamStore.teamInfo.isCaptain
    ) {
      // 因为团队赛里canSubmit变成了队长和副队长都为true 所以要给测评环节和面试预约环节多加一个是队长和是团队赛的判断 个人赛这两个环节都可见
      return null;
    }
    if (this.props.node.stageType === $const.STAGE_TYPE.JUDGE) {
      // 测评环节特殊处理
      return (
        registrationStageStatusId && (
          <GameJudgeForm
            gameData={this.props.gameData}
            stageId={this.props.node.id}
            registrationStageStatusId={registrationStageStatusId}
          ></GameJudgeForm>
        )
      );
    }
    if (this.props.node.stageType === $const.STAGE_TYPE.MEETING) {
      // 面试预约环节特殊处理
      return (
        <GameMeetingForm
          gameData={this.props.gameData}
          stageId={this.props.node.id}
          meeting={this.props.node.meeting}
        />
      );
    }
    // 表单配置起码两个以上 一个提交按钮
    if (!formInputs || formInputs < 1) {
      return null;
    }
    return (
      <GameForm
        stageId={this.props.node.id}
        meeting={this.props.node.meeting}
        myFlow={this.props.myFlow}
        gameType={this.props.gameType}
        gameData={this.props.gameData}
        node={this.props.node}
        beginAt={this.props.node.beginAt}
        endAt={this.props.node.beginAt}
        formInputs={formInputs}
        feedBackInputs={feedBackInputs}
        status={status}
        isRegistration={this.props.index === 0}
        isLoop={this.props.node.stageType === $const.STAGE_TYPE.LOOP}
        form={form}
        submitCount={submitCount}
      />
    );
  };

  renderForm = (isCurrent, node, form, formInputs, feedBackInputs, submitCount, isOverLimitCur) => {
    // 处于当前环节 状态不能等于通过以及失败 时间在范围之内
    // 报名环节特殊处理  （时间未结束，状态是失败）
    // 提交次数超出当天限制
    if (isOverLimitCur) return null;
    if (
      this.props.gameData &&
      this.props.gameData.event &&
      this.props.gameData.event.category &&
      this.props.gameData.event.category.eventType === 999
    ) {
      return (
        <div className="node-form">
          {this.renderFormContent(
            form,
            node.myStageStatus,
            formInputs,
            feedBackInputs,
            this.props.canSubmit,
            submitCount
          )}
        </div>
      );
    } else if (
      (isCurrent &&
        node.myStageStatus !== $const.STAGE_STATUS.FAIL &&
        node.myStageStatus !== $const.STAGE_STATUS.PASS &&
        moment() < moment(this.props.node.endAt) &&
        moment() > moment(this.props.node.beginAt)) ||
      (this.props.node.stageType === $const.STAGE_TYPE.LOOP &&
        node.myStageStatus === $const.STAGE_STATUS.FAIL &&
        moment() < moment(this.props.node.endAt))
    ) {
      // 子环节 非 选做环节 父环节有状态 应该显示关闭 不显示表单内容
      if (
        node.parentStageId &&
        !node.isOptional &&
        (node.parentStageStatus === $const.STAGE_STATUS.FAIL ||
          node.parentStageStatus === $const.STAGE_STATUS.PASS)
      ) {
        return null;
      }
      return (
        <div className="node-form">
          {this.renderFormContent(
            form,
            node.myStageStatus,
            formInputs,
            feedBackInputs,
            this.props.canSubmit,
            submitCount
          )}
        </div>
      );
    }
    return null;
  };

  renderIsClose = (node, history) => {
    const stageIdMajorNum = this.props.stageIdMajorNum;
    if (stageIdMajorNum !== undefined && node.majorNum > stageIdMajorNum) {
      // 环节未走过
      return null;
    }

    // 1,子环节； 2,子环节没有状态；3,子环节不是选做环节；4,父环节通过/未通过
    if (
      node.parentStageId &&
      node.myStageStatus !== $const.STAGE_STATUS.FAIL &&
      node.myStageStatus !== $const.STAGE_STATUS.PASS &&
      !node.isOptional &&
      (node.parentStageStatus === $const.STAGE_STATUS.FAIL ||
        node.parentStageStatus === $const.STAGE_STATUS.PASS)
    ) {
      return (
        <div className="node-finish">
          <div className="status grey">
            <Language resource="IS_CLOSED" />
          </div>
          {history.length > 0 ? (
            <div className="show-form spe-link" onClick={this.showFormDetail.bind(this)}>
              {this.state.showFormHistory ? (
                <Language resource="PACK_UP" />
              ) : (
                <Language resource="VIEW" />
              )}
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  renderStatus = (node, history) => {
    const stageIdMajorNum = this.props.stageIdMajorNum;
    const stageMap = toJS(this.props.teamStore.stageMap);
    // 是否是多人测评
    const isMutiJudge =
      this.props.node.stageType === $const.STAGE_TYPE.JUDGE &&
      stageMap[this.props.stageId] &&
      stageMap[this.props.stageId].forMultiPeople;
    // 非loop环节状态只有失败或者通过
    if (
      ((node.myStageStatus === $const.STAGE_STATUS.PASS ||
        node.myStageStatus === $const.STAGE_STATUS.FAIL) &&
        this.props.node.stageType !== $const.STAGE_TYPE.LOOP) ||
      // loop环节只有通过
      (this.props.node.stageType === $const.STAGE_TYPE.LOOP &&
        node.myStageStatus === $const.STAGE_STATUS.PASS)
    ) {
      if (stageIdMajorNum !== undefined && node.majorNum > stageIdMajorNum) {
        // 环节未走到
        return <div className="node-finish"></div>;
      } else {
        return (
          <div className="node-finish">
            <div>
              {/* 通过或者不通过 */}
              {node.myStageStatus === $const.STAGE_STATUS.PASS ? (
                <div className="status">
                  <Language resource="PASS" />
                </div>
              ) : (
                <div className="status grey">
                  <Language resource="FAIL" />
                </div>
              )}
              {/* 查看收起 */}
              {history.length > 0 ||
              (node.meeting && node.meeting.hasSubmittedMeeting) ||
              isMutiJudge ? (
                <div className="show-form spe-link" onClick={this.showFormDetail.bind(this)}>
                  {this.state.showFormHistory ? (
                    <Language resource="PACK_UP" />
                  ) : (
                    <Language resource="VIEW" />
                  )}
                </div>
              ) : null}
            </div>
          </div>
        );
      }
    }
    return null;
  };
  renderTime = () => {
    const stageMap = toJS(this.props.teamStore.stageMap);
    const isMutiJudge =
      this.props.node.stageType === $const.STAGE_TYPE.JUDGE &&
      stageMap[this.props.stageId] &&
      stageMap[this.props.stageId].forMultiPeople;
    const lang = this.props.languageStore.lang;
    if (isMutiJudge && this.state.isCountDown) {
      return (
        this.state.isCountDown &&
        moment(this.state.target).valueOf() > 0 && (
          <div className="node-finish">
            <div className="judge-end-time">
              <div className="judge-end-time-text">
                {this.props.languageStore.getResource(lang, "MUTI_END_TIME")}
              </div>
              <CountDown
                target={moment(moment(this.state.target).valueOf() + 3000)}
                onEnd={this.getNewJudgeLink}
              ></CountDown>
            </div>
          </div>
        )
      );
    }
    return null;
  };
  getNewJudgeLink = () => {
    this.setState(
      {
        isCountDown: false,
        registrationStageStatusId: undefined
      },
      () => {
        this.getQuizData(true);
      }
    );
  };
  renderDetailButton = detail => {
    if (!detail) return null;
    if (this.state.allDesc) {
      return (
        <div className="pack-up-button">
          <a onClick={this.closeAllInfo.bind(this)}>
            <Language resource="PACK_UP" />
          </a>
        </div>
      );
    } else {
      return (
        <a className="detail-info-button" onClick={this.showAllInfo.bind(this)}>
          <Language resource="DETAIL_INFO" />
        </a>
      );
    }
  };

  // 判断当天提交次数是否超出限制
  judgeIsOverLimit = (limited, limitedNums, curTime, commonInputs) => {
    if (
      !limited ||
      limitedNums <= 0 ||
      !(commonInputs && commonInputs.nodes && commonInputs.nodes.length > 0)
    )
      return false;
    const curDaySubmissionNum = commonInputs.nodes.filter(item => {
      const createTime = new Date(item.createdAt).getTime();
      return $util.isSameDay(createTime, curTime);
    }).length;
    console.log(`当天已经提交${curDaySubmissionNum}次数，允许最多提交${limitedNums}次`);
    return curDaySubmissionNum >= limitedNums;
  };

  render() {
    const lang = this.props.languageStore.lang;
    const node = this.props.node;
    const limited = this.props.limited;
    const limitedNums = this.props.limitedNums;
    const curTime = this.props.curTime;
    let forms = [];
    let history = [];
    let formInputs = [];
    let feedBackInputs = [];
    let commonInputs = [];
    let formId = "";
    commonInputs = this.formCommonInputs(this.props.gameData);
    // 当前用户当前环节已经提交的次数
    const submitCount = commonInputs.nodes ? commonInputs.nodes.length : 0;
    if (node.forms && node.forms.nodes && node.forms.nodes.length > 0) {
      // form表单信息
      forms = [...node.forms.nodes];
      if (
        forms[0].formInputs &&
        forms[0].formInputs.nodes &&
        forms[0].formInputs.nodes.length > 0
      ) {
        // 报名系统配置的formId
        formId = forms[0].id;
        // 筛选 报名系统归属
        formInputs = this.formatInput([...forms[0].formInputs.nodes]);
        // 筛选 cms 可见归属
        feedBackInputs = this.feedBackInput([...forms[0].formInputs.nodes]);
        history = $util.getFormHistory(formId, commonInputs, formInputs, feedBackInputs);
      }
    }

    const isOverLimitCur = this.judgeIsOverLimit(limited, limitedNums, curTime, commonInputs);

    const isCurrent = this.checkCurrent(node.id, node.parentStageId, node);

    const submitLimit = this.getFormIsSubmit(forms);

    let detail = "";
    if (node && node.paragraphs && node.paragraphs.nodes && node.paragraphs.nodes.length > 0) {
      node.paragraphs.nodes.forEach(item => {
        if (item.paragraphType === $const.PARAGRAPHTYPE.DETAIL) {
          detail = item.nameUuidI18n[lang];
        }
      });
    }
    if ($util.isEmptyRichText(detail)) {
      // 先强制赋值 带解决编辑器的问题后可去掉
      detail = "";
    }
    // 是否是专属招聘活动
    const isExclusiveEvent =
      this.props.gameData &&
      this.props.gameData.event &&
      this.props.gameData.event.category &&
      this.props.gameData.event.category.eventType === 999;

    return (
      <div className="game-info-item">
        <div
          className="game-info-item-content"
          data-log={$util.log({
            processId: this.props.index + 1
          })}
        >
          <div className="fl-l">
            <div className="node-name">{this.props.index + 1}</div>
          </div>
          <div className="fl-r">
            <div className="node-main">
              <div className="node-title">{node.nameUuidI18n[lang]}</div>
              <div className="node-desc">
                {this.state.allDesc ? this.renderDetail(detail) : this.renderSummary(node, lang)}
                {this.renderDetailButton(detail)}
              </div>
            </div>
            {isExclusiveEvent ? <div /> : this.renderStatus(node, history)}
            {this.renderTime()}
            {isExclusiveEvent === 999 ? <div /> : this.renderIsEnd(isCurrent, node, history)}
            {isExclusiveEvent ? <div /> : this.renderNotBegin(isCurrent, node)}
            {isExclusiveEvent ? <div /> : this.renderIsClose(node, history)}
            {this.renderSubmitLimit(isCurrent, node, submitLimit, history, isOverLimitCur)}
            {this.renderForm(
              isCurrent,
              node,
              forms[0],
              formInputs,
              feedBackInputs,
              submitCount,
              isOverLimitCur
            )}
            {this.renderHistroy(node, isCurrent, submitLimit || isOverLimitCur, history, formId)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/game/gameInfoItem.js